webpackJsonp([124249628159511],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ArlingtonImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArlingtonLocation = function (_React$Component) {
	  _inherits(ArlingtonLocation, _React$Component);
	
	  function ArlingtonLocation() {
	    _classCallCheck(this, ArlingtonLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ArlingtonLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Arlington, VA' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'Promoting Ridership',
	        title: 'The Kids are Alright',
	        story: 'The Youth Bike Summit is structured around the idea that children can become leaders in bicycle advocacy and help push for social change. The 2017 Summit attracted a diverse mix of participants, and featured a number of youth presenters who spoke to topics from how racing helps teach life skills and gives troubled youth a positive activity, to sexism in racing and how riding bikes can be an opportunity for transgender youth to express their authentic selves. Attendees were inspired by stories of kids who found focus and goals within bike racing, gained employment at bike shops, and were encouraged to "go beyond your neighborhoods, beyond what you know" and to fight for equity and representation for women and people of color.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Arlington, VA 1-2',
	        alt: 'Youth Bike Summit Conference photos',
	        sizes: this.props.data.arlingtonOneTwoImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Iowa',
	        prevLocationPath: 'iowa',
	        prevLocationImgPath: this.props.data.arlingtonPrevImage,
	        nextLocationName: 'St. Pete Beach, FL',
	        nextLocationPath: 'st-pete-beach',
	        nextLocationImgPath: this.props.data.arlingtonNextImage
	      })
	    );
	  };
	
	  return ArlingtonLocation;
	}(_react2.default.Component);
	
	exports.default = ArlingtonLocation;
	
	// GraphQL query
	
	var ArlingtonImageQuery = exports.ArlingtonImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-arlington-js-7a00b291a183769bf842.js